import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';

// Analytics
import Analytics from './pages/analytics/Analytics';
import ActivityLog from './pages/analytics/ActivityLog';

// User Management
import UserList from './pages/users/UserList';
import UserDetails from './pages/users/UserDetails';
import AdminUserList from './pages/users/AdminUserList';
import SessionList from './pages/users/SessionList';

// Content Management
import ArticleList from './pages/content/ArticleList';
import ArticleForm from './pages/content/ArticleForm';
import DuaList from './pages/content/DuaList';
import DuaForm from './pages/content/DuaForm';
import InsightList from './pages/content/InsightList';
import InsightForm from './pages/content/InsightForm';
import CategoryList from './pages/content/CategoryList';

// Engagement
import BroadcastForm from './pages/notifications/BroadcastForm';
import BroadcastHistory from './pages/notifications/BroadcastHistory';
import NotificationTemplates from './pages/notifications/NotificationTemplates';

// Media
import MediaLibrary from './pages/media/MediaLibrary';
import ContactInfo from './pages/contact/ContactInfo';

// System
import { isAuthenticated } from './services/auth';
import ReportsPage from './pages/reports/ReportsPage';
import CsvDataManagement from './pages/reports/CsvDataManagement';

//Not found
import NotFound from './pages/NotFound';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />

        {/* Protected Routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          {/* Main */}
          <Route index element={<Dashboard />} />
          <Route path="analytics" element={<Analytics />} />

          {/* User Management */}
          <Route path="users" element={<UserList />} />
          <Route path="users/:id" element={<UserDetails />} />
          <Route path="admin-users" element={<AdminUserList />} />
          <Route path="sessions" element={<SessionList />} />

          {/* Content Management */}
          <Route path="articles" element={<ArticleList />} />
          <Route path="articles/new" element={<ArticleForm />} />
          <Route path="articles/edit/:id" element={<ArticleForm />} />

          <Route path="duas" element={<DuaList />} />
          <Route path="duas/new" element={<DuaForm />} />
          <Route path="duas/edit/:id" element={<DuaForm />} />

          <Route path="insights" element={<InsightList />} />
          <Route path="insights/new" element={<InsightForm />} />
          <Route path="insights/edit/:id" element={<InsightForm />} />

          <Route path="categories" element={<CategoryList />} />

          {/* Engagement */}
          <Route path="notifications" element={<BroadcastForm />} />
          <Route path="broadcasts" element={<BroadcastHistory />} />
          <Route path="notification-templates" element={<NotificationTemplates />} />

          {/* Media */}
          <Route path="media" element={<MediaLibrary />} />
          <Route path="contact" element={<ContactInfo />} />

          {/* System */}
          <Route path="activity-log" element={<ActivityLog />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="csv-data" element={<CsvDataManagement />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;